export type ActionType =
  | 'navigate'
  | 'log_activity'
  | 'open_camera'
  | 'show_market_prices'
  | 'show_planting_guide'
  | 'show_weather'
  | 'connect_farmer'
  | 'view_details';

export interface ParsedAction {
  type: ActionType;
  params?: Record<string, any>;
  requiresConfirmation?: boolean;
}

export class ConversationActions {
  parseAction(action: string): ParsedAction | null {
    const actionMap: Record<string, ParsedAction> = {
      log_activity: { type: 'log_activity' },
      open_camera: { type: 'open_camera' },
      take_photo: { type: 'open_camera' },
      show_market_prices: { type: 'navigate', params: { screen: '/network' } },
      show_planting_guide: { type: 'navigate', params: { screen: '/' } },
      show_weather: { type: 'show_weather' },
      check_score: { type: 'navigate', params: { screen: '/score' } },
      view_details: { type: 'view_details' },
      connect_farmer: { type: 'connect_farmer', requiresConfirmation: true },
    };

    return actionMap[action] || null;
  }

  async executeAction(action: ParsedAction, navigate?: (path: string) => void): Promise<void> {
    switch (action.type) {
      case 'navigate':
        if (navigate && action.params?.screen) {
          navigate(action.params.screen);
        }
        break;

      case 'log_activity':
        if (navigate) {
          navigate('/activity-log');
        }
        break;

      case 'open_camera':
        if (navigate) {
          navigate('/camera');
        }
        break;

      case 'show_weather':
        // Could trigger a weather modal or card
        console.log('Showing weather details');
        break;

      case 'view_details':
        // Show details modal
        console.log('Viewing details');
        break;

      case 'connect_farmer':
        // Navigate to network or show connection modal
        if (navigate) {
          navigate('/network');
        }
        break;

      default:
        console.warn('Unknown action type:', action.type);
    }
  }

  getQuickActions() {
    return [
      { id: 'weather', label: 'Check Weather', icon: 'Cloud', action: 'show_weather' },
      { id: 'log', label: 'Log Activity', icon: 'Calendar', action: 'log_activity' },
      { id: 'camera', label: 'Take Photo', icon: 'Camera', action: 'open_camera' },
      { id: 'market', label: 'Market Prices', icon: 'TrendingUp', action: 'show_market_prices' },
    ];
  }
}

export const conversationActions = new ConversationActions();
